<template>
  <div>
    <h3>请选择GPS设备：</h3>
    <el-select
      style="width: 70%"
      v-model="selectGap"
      clearable
      filterable
      placeholder="请选择"
    >
      <el-option
        v-for="item in options"
        :key="item.code"
        :label="item.gpsNo"
        :value="item.code"
      >
      </el-option>
    </el-select>
    <el-button @click="bindVehicleApi" type="primary" style="margin-left:40px;"
      >绑定</el-button
    >
  </div>
</template>
<script>
import { baseGpsList, bindVehicle } from "@/api/gps";
export default {
  name: "compBindLightVehicle",
  props: {
    rowInfoItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectGap: "",
      gpsList: [],
      options: []
    };
  },
  mounted() {
    this.getGpsList();
  },
  methods: {
    bindVehicleApi() {
      bindVehicle({
        code: this.selectGap,
        vehicleCode: this.rowInfoItem.code,
        licenseNumber: this.rowInfoItem.licenseNumber,
        driverName: this.rowInfoItem.driverName,
        driverPhone: this.rowInfoItem.driverPhone
      }).then(res => {
        if (res.status === 0) {
          this.$message({
            message: "绑定成功",
            type: "success"
          });
          this.$emit("close");
        }
      });
    },
    getGpsList() {
      baseGpsList({
        pageNum: 1,
        pageSize: 2000,
        notBind: true
      })
        .then(res => {
          console.log("=============================", res);
          if (res.status === 0) {
            const records = (res.data && res.data.records) || [];
            this.gpsList = records;
            this.options = records;
          }
        })
        .catch(() => {
          this.gpsList = [];
          this.options = [];
        });
    }
  }
};
</script>
